// eslint-disable
import React, { useEffect, useState } from 'react';

import { Box } from '@mui/material';

import filesAPI from '@/api/files';
import ordersAPI from '@/api/ordersV2';
import Modal from '@/components/Modals/Modal';
import stage from '@/constants/stage';
import IDesign from '@/types/IDesign';
import IFile from '@/types/IFile';
import { IOrderDetailUpdate } from '@/types/IOrderDetail';
import IOrderV2, { OrderTag } from '@/types/IOrderV2';
import IOrder from '@/types/IOrderV2';

import FileUploadComponent from '../../FileUploadComponent';
import OrderDetailModal from '../../OrderDetailModal';
// eslint-disable-next-line import/no-cycle
import OrderDetailCommentBox from './OrderDetailCommentBox';
import OrderDetailInformationBox from './OrderDetailInformationBox';

export interface IOrderFeedbackItem {
  change_request: IChangeRequest;
  change_request_file: IFile[] | [];
}

interface IChangeRequest {
  id: number;
  note: string;
  inserted_at: any;
  participant_name: string;
  type: string;
}

interface IOrderDetailsProps {
  orderId: number;
  orgId: number;
  orderStage: string;
  isOpenOrderDetailModal: boolean;
  setIsOpenOrderDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
  setIsMoveOrder: React.Dispatch<React.SetStateAction<boolean>>;
  orderAlternateEmail?: string;
  orderAlternateEmailFlag: boolean;
  orderNumber: string;
  isPriority?: boolean;
  handleClickLinkedOrg: (orgId: number) => void;
  handleOrderStatusChange: () => void;
  tag?: OrderTag;
  customerName: string;
  customerEmail: string;
  orderStatusUrl: string;
  order: IOrder;
}

const OrderDetails = (props: IOrderDetailsProps) => {
  const {
    orderId,
    orgId,
    orderStage,
    isOpenOrderDetailModal,
    setIsOpenOrderDetailModal,
    setIsMoveOrder,
    orderAlternateEmail,
    orderAlternateEmailFlag,
    orderNumber,
    isPriority,
    handleClickLinkedOrg,
    handleOrderStatusChange,
    tag,
    customerName,
    customerEmail,
    orderStatusUrl,
    order,
  } = props;

  // Order detail show
  const [orderComment, setOrderComment] = useState<IOrderFeedbackItem[]>([]);
  const [orderDesign, setOrderDesign] = useState<IDesign[]>([]);
  const [organisationPastOrder, setOrganisationPastOrder] = useState<
    IOrderV2[]
  >([]);

  const [updateOrderStatus, setUpdateOrderStatus] =
    useState<string>(orderStage);

  // Order detail comment
  const [newComment, setNewComment] = useState<string>('');
  const [newCommentFile, setNewCommentFile] = useState<File[]>([]);
  const [sendFeedBackStatus, setSendFeedBackStatus] = useState<boolean>(false);

  // Alternate email
  const [inputAlternateEmail, setInputAlternateEmail] = useState<string>(
    orderAlternateEmail || '',
  );
  const [isAlternateEmailValid, setIsAlternateEmailValid] =
    useState<boolean>(true);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  // Modal upload design
  const [isUploadDesign, setIsUploadDesign] = useState<boolean>(false);
  const [orderDesignFile, setOrderDesignFile] = useState<File>();

  const [sentToClientFlag, setSentToClientFlag] = useState<boolean>(false);
  const [orderTag, setOrderTag] = useState<OrderTag | undefined>(tag);
  const [orderDesignFileMessage, setOrderDesignFileMessage] =
    useState<string>('');
  const [isRerender, setIsReRender] = useState<boolean>(false);

  const handleUpdateOrderDetail = async (
    stage?: string,
    alternate_email?: string,
    priority?: boolean,
    alternate_email_flag?: boolean,
    orderTag?: string,
  ) => {
    await ordersAPI.updateOrderDetail(
      orderId,
      stage,
      alternate_email,
      priority,
      alternate_email_flag,
      orderTag,
    );
  };

  // Order detail checkbox
  const [orderDetailUpdate, setOrderDetailUpdate] =
    useState<IOrderDetailUpdate>({
      high_priority: isPriority || false,
      alternate_email: orderAlternateEmailFlag,
    });

  useEffect(() => {
    if (isOpenOrderDetailModal) {
      ordersAPI
        .showOrderChangeRequest(orderId)
        .then(res => {
          if (res.data.data) {
            setOrderComment(res.data.data);
          }
        })
        .catch(err => console.log('get change request errors: ', err));
    }
  }, [orderId, sendFeedBackStatus, isOpenOrderDetailModal, isRerender]);

  useEffect(() => {
    if (isOpenOrderDetailModal) {
      ordersAPI
        .organisation_past_order(orgId)
        .then(past_order => {
          if (past_order.data.data) {
            setOrganisationPastOrder(past_order.data.data);
          }
        })
        .catch(err => console.log('get organisation order errors: ', err));
    }
  }, [orderId, isOpenOrderDetailModal]);

  useEffect(() => {
    if (isOpenOrderDetailModal)
      ordersAPI
        .showOrderDesignFile(orderId)
        .then(res => {
          setOrderDesign(res.data);
        })
        .catch(err => console.log('get order designs errors: ', err));
  }, [orderId, isOpenOrderDetailModal]);

  useEffect(() => {
    if (isOpenOrderDetailModal)
      setInputAlternateEmail(orderAlternateEmail || '');
    setIsLoading(false);
  }, [isOpenOrderDetailModal]);

  const handleUploadChangeRequestFiles = (files: FileList) => {
    Array.from(files).forEach(file => {
      setNewCommentFile(prevFiles => [...prevFiles, file]);
    });
  };

  const handleSendOrderFeedback = (files: File[]) => {
    if (newCommentFile.length !== 0 || newComment !== '') {
      Promise.all(
        Array.from(files).map(file => {
          return filesAPI
            .createAndUploadOrderFile(orgId, new File([file], file.name))
            .then(res => res?.data?.data?.id)
            .catch(err => {
              console.log(err);
              return null;
            });
        }),
      ).then(fileIds => {
        const validFileIds = fileIds.filter((id): id is number => id !== null);
        ordersAPI
          .AdminOrderChangeRequest(orderId, newComment, validFileIds)
          .then(() => {
            setSendFeedBackStatus(!sendFeedBackStatus);
            setNewComment('');
          })
          .finally(() => {
            setNewCommentFile([]);
            setNewComment('');
          });
      });
    }
  };

  const handleSendOrderDesignFile = async (file: File) => {
    if (orderDesignFile) {
      await filesAPI
        .createAndUploadOrderFile(orgId, new File([file], file.name))
        .then(res => {
          // Update Order changerequest
          ordersAPI
            .AdminOrderChangeRequest(orderId, orderDesignFileMessage, [
              res?.data?.data?.id,
            ])
            .finally(() => {
              setOrderDesignFile(undefined);
            });
          // Update order file and send to client
          ordersAPI.uploadFile(orderId, res?.data?.data?.id, sentToClientFlag);
          // Update order design file
          ordersAPI.uploadOrderDesign(orderId, orgId, [res?.data?.data?.id]);
        })
        .catch(err => {
          console.log(err);
          return null;
        });
    }
  };

  const handleSubmitOrderDetailModal = async () => {
    if (isAlternateEmailValid) {
      setIsLoading(true);

      if (orderDesignFile) {
        await handleUpdateOrderDetail(
          'awaiting_client',
          inputAlternateEmail,
          orderDetailUpdate.high_priority,
          orderDetailUpdate.alternate_email,
          orderTag,
        );
        await handleSendOrderDesignFile(orderDesignFile);
      } else {
        orderTag === stage.order_tag.find(tag => tag.name === 'on_hold')?.value
          ? await handleUpdateOrderDetail(
              'on_hold',
              inputAlternateEmail,
              orderDetailUpdate.high_priority,
              orderDetailUpdate.alternate_email,
              orderTag,
            )
          : await handleUpdateOrderDetail(
              updateOrderStatus,
              inputAlternateEmail,
              orderDetailUpdate.high_priority,
              orderDetailUpdate.alternate_email,
              orderTag,
            );
      }

      handleSendOrderFeedback(newCommentFile);
      handleOrderStatusChange();

      setIsOpenOrderDetailModal(false);
    }
  };

  return (
    <OrderDetailModal
      isOpen={isOpenOrderDetailModal}
      setIsOpen={setIsOpenOrderDetailModal}
      successButtonText="Save & Exit"
      isDisabled={!isAlternateEmailValid}
      isLoading={isLoading}
      onSuccess={() => {
        handleSubmitOrderDetailModal();
      }}
      cancelButtonText="Close"
      large
      wider
    >
      <Box className="grid grid-cols-2 gap-11">
        <OrderDetailCommentBox
          order={order}
          orderComment={orderComment}
          newComment={newComment}
          setNewComment={setNewComment}
          newCommentFile={newCommentFile}
          setNewCommentFile={setNewCommentFile}
          onFileSelected={handleUploadChangeRequestFiles}
          handleSendOrderFeedback={handleSendOrderFeedback}
          orderDesignFile={orderDesignFile}
          setOrderDesignFile={setOrderDesignFile}
          orderId={orderId}
          isRerender={isRerender}
          setIsReRender={setIsReRender}
        />
        <OrderDetailInformationBox
          inputAlternateEmail={inputAlternateEmail}
          setInputAlternateEmail={setInputAlternateEmail}
          setIsAlternateEmailValid={setIsAlternateEmailValid}
          handleClickLinkedOrg={handleClickLinkedOrg}
          orgID={orgId}
          setIsMoveOrder={setIsMoveOrder}
          orderDetailUpdate={orderDetailUpdate}
          setOrderDetailUpdate={setOrderDetailUpdate}
          setIsUploadDesign={setIsUploadDesign}
          orderDesign={orderDesign}
          organisationPastOrder={organisationPastOrder}
          orderNumber={orderNumber}
          orderStatusUrl={orderStatusUrl}
          updateOrderStatus={updateOrderStatus}
          setUpdateOrderStatus={setUpdateOrderStatus}
          orderId={orderId}
          orderTag={orderTag}
          setOrderTag={setOrderTag}
          customerName={customerName}
          customerEmail={customerEmail}
          order={order}
        />
      </Box>
      <Modal
        key="Upload-Design-Modal"
        isOpen={isUploadDesign}
        setIsOpen={setIsUploadDesign}
        dialogTitle="Drag And Drop File"
        dialogDescription="Upload desired files"
        successButtonText="Upload"
        checkboxDescription="I want this sent to the client"
        onSuccess={() => {
          setIsUploadDesign(false);
          if (orderDesignFile) {
            sentToClientFlag
              ? setOrderDesignFileMessage('Design sent to client')
              : setOrderDesignFileMessage('');
          }
          if (!orderDesignFile) {
            setSentToClientFlag(false);
          }
        }}
        onCancel={() => {
          if (orderDesignFile) {
            sentToClientFlag
              ? setOrderDesignFileMessage('Design sent to client')
              : setOrderDesignFileMessage('');
          }
          if (!orderDesignFile) {
            setSentToClientFlag(false);
          }
        }}
        onClose={() => {
          if (!orderDesignFile) {
            setOrderDesignFileMessage('');
            setSentToClientFlag(false);
          }
          setIsUploadDesign(false);
        }}
        checkbox={sentToClientFlag}
        setCheckbox={setSentToClientFlag}
      >
        <div className="pb-8">
          <FileUploadComponent
            onFileSelected={(file: File) => {}}
            fileFormat=".svg, .eps, .ai, .indd, .pdf"
            fileFormatMessage="(.svg, .eps, .ai, .indd, or .pdf only)"
            file={orderDesignFile}
            setFile={setOrderDesignFile}
          />
        </div>
      </Modal>
    </OrderDetailModal>
  );
};

export default OrderDetails;
